import * as React from 'react';
import { cn } from '@/lib/utils';

const BannerInfo = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex flex-wrap items-center gap-5 rounded-[10px] border border-solid border-[#F6F6FA] bg-white px-4 py-3', 'animate-fade-in shadow-[0px_4px_10px_rgba(68,43,140,0.1)]', className)}
    {...props}
  />
));
BannerInfo.displayName = 'BannerInfo';

const BannerInfoContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('relative ml-7 flex-grow', className)}
    {...props}
  />
));
BannerInfoContent.displayName = 'BannerInfoContent';

const BannerInfoIcon = React.forwardRef(({ className, ...props }, ref) => (
  <span
    ref={ref}
    className={cn('absolute left-[-28px] top-0 flex h-[22px] w-[22px] items-center justify-center rounded-full bg-primary-lightest text-primary', className)}
    {...props}
  />
));
BannerInfoIcon.displayName = 'BannerInfoIcon';

const BannerInfoTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('text-sm font-bold text-black', 'mb-0', className)}
    {...props}
  />
));
BannerInfoTitle.displayName = 'BannerInfoTitle';

const BannerInfoDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn('mb-0 text-sm font-light text-neutral', className)}
    {...props}
  />
));
BannerInfoDescription.displayName = 'BannerInfoDescription';

export { BannerInfo, BannerInfoContent, BannerInfoIcon, BannerInfoTitle, BannerInfoDescription };
